<template>
  <el-tooltip
    class="item"
    :open-delay="1000"
    effect="dark"
    :content="`このレッスンのロックを解除するには合計で${scoreNeedTotalUnlock}点の累計スコアが必要で${lock ? 'す' : 'した'}`"
    placement="bottom"
    v-if="$route.name === 'Dashboard'"
  >
    <div class="wrapper">
      <div class="score-need-to-unlock" v-show="lock">残り{{ Math.ceil(scoreNeedToUnlock) }}点が必要です</div>
      <div
        class="unlocked-badge"
        v-show="recentlyUnlocked && !first && !$store.state.userData.unlock"
      >
        <i class="el-icon-check" style="margin-right: 4px" />
        解除されました！
      </div>
      <div
        class="inner"
        :class="[{ 'vowel-bg': lesson.category === 'vowel' }, { disabled: lock }]"
        @click="goToLesson(lesson)"
      >
        <el-tooltip
          class="item"
          :open-delay="500"
          effect="dark"
          content="このレッスンを行うにはスコアを溜めるか購入する必要があります"
          placement="top"
        >
          <div class="lock" v-show="lock">
            <div class="lock-overlay"></div>
            <img src="@/assets/lock.svg" alt="locked" />
          </div>
        </el-tooltip>
        <div
          class="category"
          :style="
          `background-color:${lesson.category === 'vowel' ? '#f88' : '#555'};
               color:${lesson.category === 'vowel' ? 'white' : 'white'}`
        "
        >{{ lesson.category === "vowel" ? "母音" : "子音" }}</div>
        <div class="type">{{ lesson.type }}</div>

        <div class="example">{{ lesson.example }}の</div>

        <div class="target-phoneme">{{ lesson.titlePhoneme }}</div>

        <div
          v-show="!lock"
          class="lesson-nav-btn"
          :class="[
          { vowel: lesson.category === 'vowel' },
          { consonant: lesson.category === 'consonant' }
        ]"
        >/{{ lesson.targetPhoneme }}/のレッスンへ</div>

        <ProgressCircle class="progress" :percentage="Math.ceil(completed)" />
      </div>
    </div>
  </el-tooltip>
</template>

<script>
const workbooks = require("@/resources/workbooks");
import problemResultRepo from "@/utils/ProblemResultRepository";
import { CLEAR_SCORE } from "@/constants";

export default {
  components: {
    ProgressCircle: require("@/components/ProgressCircle").default
  },
  props: [
    "lesson",
    "lock",
    "cleared",
    "completed",
    "recentlyUnlocked",
    "scoreNeedToUnlock",
    "scoreNeedTotalUnlock",
    "first",
    "targetBlank"
  ],
  data() {
    return {
      achieved: 0,
      total: 0,
      negativeMargins: {
        b: "-18px"
      },
      problemResults: {}
    };
  },
  methods: {
    goToLesson(lesson) {
      let routeData = this.$router.resolve({ path: 'lesson', query: { category: lesson.titlePhoneme }});
      if(this.targetBlank){
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push({ path: 'lesson', query: { category: lesson.titlePhoneme }});
      }

      // this.$router.push({
      //   path: "lesson",
      //   query: { category: lesson.titlePhoneme }
      // });

      
    },
    loadAchievement() {
      return 0;
    }
  },
  mounted() {
    let self = this;
    let clearedNumber = 0;
    // problemResultRepo
    //   .getResults()
    //   .then(results => {
    //     const cleared = results.filter(result => {
    //       return (
    //         result.phoneme === this.lesson.targetPhoneme && result.score >= 80
    //       );
    //     }).length;

    //     const currentWorkbooks = workbooks.filter(workbook => {
    //       return workbook.targetPhoneme === this.lesson.targetPhoneme;
    //     });
    //     let total = 0;
    //     currentWorkbooks.forEach(cw => {
    //       cw.problems.forEach(pr => {
    //         total++;
    //       });
    //     });

    //     self.achieved = (cleared / total) * 100;
    //   })
    //   .catch(err => {
    //     console.log(err);
    //   });
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  outline: none;
}

.disabled {
  cursor: default;
  user-select: none;
}
.inner {
  cursor: pointer;
  width: 200px;
  height: 200px;
  position: relative;
  margin: 10px;
  padding: 10px;
  box-sizing: border-box;
  transition: all 0.3s ease;
  border-radius: 5px;
  overflow: hidden;
  background-color: #fafafa;
  /* overflow: hidden; */
  border: 1px solid #ddd;
  &:hover {
    .lesson-nav-btn {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .category {
    display: inline-block;
    padding: 2px 13px;
    font-size: 1.1rem;
    font-weight: bold;
    border-radius: 20px;
  }

  .example {
    text-align: center;
    margin-top: 12px;
    font-weight: bold;
    font-size: 1.1rem;
  }

  .target-phoneme {
    font-size: 4rem;
    font-weight: bold;
    user-select: none;
    margin-top: -20px;
    text-align: center;
  }

  .lesson-nav-btn {
    opacity: 0;
    transition: all 0.3s ease;
    transform: translateX(30px);
    font-size: 0.8rem;
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    right: 0;
    border: 0;
    color: white;
    padding: 8px 8px 8px 13px;
    margin: auto;
    border-radius: 20px 0 0 20px;
    font-weight: bold;
    z-index: 100;
  }

  .consonant {
    background-color: #555;
    &:hover {
      background-color: #444;
    }
  }

  .vowel {
    background-color: #f88;
    &:hover {
      background-color: #f77;
    }
  }

  .progress {
    position: absolute;
    bottom: 10px;
    left: 10px;
    z-index: 1;
  }
  .lock {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    .lock-overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.9);
      z-index: 10;
    }
    img {
      width: 32px;
      padding: 12px;
      background-color: white;
      border-radius: 50%;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.13);
      z-index: 11;
    }
  }

  .type {
    position: absolute;
    right: 20px;
    top: 14px;
    font-size: 0.9rem;
    color: #aaa;
  }
}

.vowel-bg {
  background-color: #ffefef;
}

.unlocked-badge {
  position: absolute;
  display: flex;
  align-items: center;
  top: -15px;
  right: 1px;
  font-size: 0.72rem;
  z-index: 50;
  background-color: #f88;
  color: #fff;
  font-weight: bold;
  padding: 3px 10px;
  border-radius: 20px;
  box-shadow: 2px 2px 3px 0 rgba(255, 0, 0, 0.3);
  img {
    width: 17px;
    margin-left: 2px;
  }
}
.score-need-to-unlock {
  user-select: none;
  left: 0;
  right: 0;
  bottom: 35px;
  margin: auto;
  text-align: center;
  color: #999;
  position: absolute;
  z-index: 90;
  font-size: 0.8rem;
  font-weight: bold;
}
</style>
